
const Tehnicar = function(DS) {
    return DS.defineResource({
        name: 'Tehnicar',
        endpoint: '/tehnicari'
    });
};

Tehnicar.$inject = ['DS'];


export {Tehnicar};



// WEBPACK FOOTER //
// ./app/models/tehnicar.js